import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const Container = styled(Flex)`
    align-items: center;
    margin-left: auto;
    opacity: 0;
    transition: opacity 0.2s ease;
`;

export const IconContainer = styled(Flex)`
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    .SWReactIcons svg {
        path {
            fill: ${carbon[300]};
            fill-opacity: 1;
        }

        polygon {
            fill: ${carbon[300]};
        }
    }
`;
